<span class="overlay"></span>
<div class="spinner-container">
  <div class="loaderMainDiv">
    <div class="loader"></div>
    <h3 class="title">{{ title | async }}</h3>
    @if (isCryptoPayment) {
    <h4 (click)="cancelCryptoPayment()" class="title cancle-button">
      Cancel and return to checkout
    </h4>
    }
  </div>
</div>
